import { FindingDto } from './finding-dto';
import { ScanModule, ScanType, Severity } from '../enums';

export interface BreachLenseFindingDto extends FindingDto {
  scanModule: ScanModule.BreachLense;
  emailAddress: string;
  passwordShortHash: string;
  maskedPassword: string;
  isFixed: boolean;
  isNewLeak: boolean;
  numberOfLeaks: number;
  affiliation: string;
}

export namespace BreachLenseFindingDto {
  export function mapFromApiValue(breachLenseFindingDto: any): BreachLenseFindingDto {
    return {
      ...breachLenseFindingDto,
      scanType: ScanType.mapFromApiValue(breachLenseFindingDto.scanType),
      scanModule: ScanModule.BreachLense,
      severity: Severity.mapFromApiValue(breachLenseFindingDto.severity),
    };
  }
}
